import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {
    const questions = [
        {
            label: "Address",
            name: 'address',
            answer: {
                type: "text",
            },
            target: `properties[${section.mortgage.property.id}].address`
        },
    ]
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}

export default ApplicationForm;